module.exports = __webpack_public_path__ + "img/kw.79a1826d.svg";